import { RouteConfig } from 'vue-router';
import combineGuards from '@/router/guards/helpers';
import { requireAuthenticated } from '@/router/guards/authGuards';
import { redirectIfEmailAlreadyVerified } from '@/router/guards/emailVerificationGuard';
import VerifyEmailPage from '@/apps/verifyEmail/VerifyEmailPage.vue';

const verifyEmailRoutes: RouteConfig[] = [
  {
    path: '/verify-email',
    name: 'VerifyEmail',
    component: VerifyEmailPage,
    beforeEnter: combineGuards([requireAuthenticated, redirectIfEmailAlreadyVerified]),
    meta: {
      hideMainHeader: true,
    },
  },
];

export default verifyEmailRoutes;
